export const no = {
	'welcome.title': 'Velkommen til Elsa',
	'welcome.subtitle': 'Applikasjonen din er klar til å bygges',
	'language.english': 'Engelsk',
	'language.norwegian': 'Norsk',
	'login.welcomeBack': 'Velkommen tilbake',
	'login.subtitle': 'Logg inn for å få tilgang til ditt produksjonsområde',
	'login.organizationalAccount': 'Bruk din organisasjonskonto for å få tilgang til systemet',
	'login.signInWithAzure': 'Logg inn med Azure',
	'login.secureAuth': 'Sikker bedriftsautentisering',
	'login.ssoEnabled': 'Enkel pålogging aktivert',
	'login.ssoDescription':
		'Du vil bli omdirigert til organisasjonens Azure-påloggingsside. Bruk bedriftens legitimasjon for å autentisere.',
	'login.badge.secureAuth': 'Sikker autentisering',
	'login.badge.cloudBased': 'Skybasert',
	'login.copyright': '© {year} FabControl. Alle rettigheter reservert.',
	'mto.emptyState': 'Ingen MTO-elementer funnet for denne bestillingen.',
	'mto.emptySearch': 'Ingen samsvarende MTO-elementer funnet',
};
